<script>
export default {
  name: 'SocialShare',
  methods: {
    facebookShare() {
      FB.ui({
        method: 'share',
        href: window.location.href,
      });
    },
  },
};
</script>
